module.exports = __webpack_public_path__ + "img/oxt.39029fe9.svg";